import { Icon, Space, Text } from 'ui';

type P = {
  type?: string;
};

const Type = ({ type }: P) => {
  if (!type) {
    return null;
  }

  return (
    <Space>
      <Icon icon="bubble-line" />
      <Text>{type}</Text>
    </Space>
  );
};

export default Type;
